export const DEFAULT_PHOEINX_SURGE_LINK = 'https://yandex.ru/legal/delivery_tou/'
export const DEFAULT_SURGE_LINK = 'https://yandex.ru/legal/logistics_terms_of_use/'
